import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import * as _ from 'lodash';

@Injectable()
export class LocationsService {
  public locations: Array<Object>;

  public locationName = new BehaviorSubject(null);

  constructor(private _http: HttpClient) {}

  public getLocations() {
    return this._http.get('./assets/fixtures/locations.json');
  }

  public getMenuLocations() {
    return this._http.get('/api/locations').catch(this.handleError);
  }

  public getLocationById(id) {
    return this._http
      .get('/api/locations')
      .map((response: Response) => {
        return _.find(response, { id: id });
      })
      .catch(this.handleError);
  }

  public updateLocationName(name) {
    if (typeof name == 'string') {
      this.locationName.next(name);
      localStorage.setItem('locationName', name);
    }
  }

  private handleError(error: Response) {
    console.error(error);
    if (error.status == 404) {
      alert(
        'Please change all references to /confidential/fixture/work.json to /fixture/work.json in the work.service.ts file'
      );
    }
    return Observable.throw(error.json().error || 'Server error');
  }
}



// WEBPACK FOOTER //
// ./src/app/services/locations/locations.service.ts